/*
 * Copyright © 2023 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import * as Sentry from '@sentry/react';
import UserHelper from '../helpers/UserHelper';
import trackerConfig from '../config/trackerConfig';

class SentryLogTracker {
  constructor() {
    const sentryConf = trackerConfig.integrations.sentry;
    Sentry.init(sentryConf);
    Sentry.setUser(UserHelper._getUser());
    Sentry.setContext('context', 'EPO');
  }

  captureException(err) {
    Sentry.captureException(err);
    return this;
  }

  log(breadcrumb) {
    Sentry.addBreadcrumb(breadcrumb);
    return this;
  }

  setTag(key, value) {
    Sentry.setTag(key, value);
    return this;
  }
}

export default SentryLogTracker;
